import React, { useEffect, useRef, useState } from "react";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useMutateUpdateVersion } from "../hooks/useApihook";
import { Field, Form, Formik } from "formik";
import {
  UpdateVersionIntialValues,
  UpdateVersionValidationSchema,
} from "../../constant";
import InputWithLabel from "../../../../Components/InputWithLabel";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { GetAppVersion } from "../../../../Api/setting";
import SaveButton from "../../../../Components/SaveButton";

const VersionSetting = () => {
  const navigate = useNavigate();
  const updateVersionApi = useMutateUpdateVersion();
  const formRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const { data: appVersionData } = useQuery({
    queryKey: ["get-app-version"],
    queryFn: () => GetAppVersion(),
    throwOnError: true,
    onError: (error) => {
      ErrorToast(
        error?.response?.data?.message || error?.message || "Server Error."
      );
    },
  });

  useEffect(() => {
    if (appVersionData) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          minimumIosVersion: appVersionData?.data?.data?.minimumIosVersion,
          minimumAndroidVersion:
            appVersionData?.data?.data?.minimumAndroidVersion,
        });
      }
    }
  }, [appVersionData]);

  const UpdateVersion = (values) => {
    const reqData = {
      minimumIosVersion: values?.minimumIosVersion,
      minimumAndroidVersion: values?.minimumAndroidVersion,
    };

    setIsLoading(true);
    updateVersionApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || " Version Updated.");
        navigate("/admin/setting");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };

  return (
    <div className="setting-border overflow-visible">
      <div className="">
        <div className="row">
          <div className="col-md-12">
            <section className="">
                  <Formik
                    initialValues={UpdateVersionIntialValues}
                    validationSchema={UpdateVersionValidationSchema}
                    validateOnChange
                    innerRef={formRef}
                    onSubmit={UpdateVersion}
                  >
                    {(formik) => {
                      const { isSubmitting, values } = formik;
                      const fetchedIosVersion = appVersionData?.data?.data?.minimumIosVersion;
                      const fetchedAndroidVersion = appVersionData?.data?.data?.minimumAndroidVersion;
                      const iosChanged = String(values?.minimumIosVersion ?? "") !== String(fetchedIosVersion ?? "");
                      const androidChanged = String(values?.minimumAndroidVersion ?? "") !== String(fetchedAndroidVersion ?? "");
                      const hasChanges = (iosChanged || androidChanged);
                      return (
                        <Form>
                          <div className="row">
                            <div className="col-md-6">
                              <Field
                                Label="Ios Version"
                                type="number"
                                name="minimumIosVersion"
                                placeholder="Enter Ios Version"
                                component={InputWithLabel}
                              />
                            </div>
                            <div className="col-md-6">
                              <Field
                                Label="Android Version"
                                type="number"
                                name="minimumAndroidVersion"
                                placeholder="Enter Android Version"
                                component={InputWithLabel}
                              />
                            </div>
                          </div>
                          {/* <div className="text-end mt-5">
                            <button
                              type="submit"
                              className="btn btn-them-gray chat-btn"
                            >
                              <GrUpdate className="icon-width-height me-2" />
                              Update Version
                            </button>
                          </div> */}
                          <SaveButton loading={isLoading} disabled={!hasChanges || isSubmitting} />
                        </Form>
                      );
                    }}
                  </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionSetting;
